var _circle, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFaqs12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 61,
    stroke: "#339999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.6408 49.7035L53.4466 38.7823C52.2709 37.6408 50.6797 37 49.021 37C47.3624 37 45.7712 37.6408 44.5954 38.7823L37.8269 45.3858C36.6568 46.5328 36 48.0852 36 49.7035C36 51.3217 36.6568 52.8741 37.8269 54.0211L49.021 64.9423",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6244 47.1636L56.831 42.084",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6572 72.5618L82.8638 67.4822",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.054 59.8625L86.2481 70.7837C88.6952 73.1711 88.6952 77.0316 86.2481 79.419L79.4796 86.0225C77.0325 88.4099 73.0755 88.4099 70.6284 86.0225L59.4342 75.1014",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9202 49.2259C87.2966 47.8834 88.0699 46.0625 88.0702 44.1637C88.0704 42.2649 87.2975 40.4438 85.9215 39.101C84.5454 37.7582 82.679 37.0037 80.7327 37.0034C78.7865 37.0032 76.9198 37.7572 75.5434 39.0997L40.7999 73.0035C40.1954 73.5915 39.7484 74.3154 39.4982 75.1116L36.0593 86.1648C35.992 86.3844 35.9869 86.6177 36.0446 86.84C36.1022 87.0622 36.2205 87.2651 36.3867 87.4271C36.553 87.589 36.7612 87.7041 36.989 87.76C37.2169 87.8158 37.4561 87.8105 37.6811 87.7445L49.0133 84.392C49.8285 84.1501 50.5705 83.7166 51.174 83.1297L85.9202 49.2259Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8474 44.6238L80.2606 54.783",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs12);
export default __webpack_public_path__ + "static/media/IconFaqs12.24ee447d9dd16d3191f6f1d736acbe16.svg";
export { ForwardRef as ReactComponent };